import type { Field, Section } from '../types';
import type { FieldTypeRegistry } from '../fieldTypes/registry';
import { newId } from './id';

export function createField(fieldTypeKey: string, section: Section, registry: FieldTypeRegistry): Field {
  const def = registry[fieldTypeKey];
  const order = section.fields.length;
  return {
    id: newId(),
    sectionId: section.id,
    label: def?.label ?? 'New field',
    handle: `field_${order + 1}_${newId().slice(0, 8)}`,
    fieldType: fieldTypeKey,
    order,
    isRequired: false,
    isHidden: false,
    ...def?.defaultProps,
  };
}

export function createSection(order: number, parentId?: string): Section {
  return {
    id: newId(),
    name: `Section ${order + 1}`,
    label: parentId ? `Subsection ${order + 1}` : `Section ${order + 1}`,
    order,
    parentId,
    fields: [],
  };
}
